/**
 * API Configuration
 * Automatically determines the correct backend URL based on the environment
 */

// Dynamically determine API URL - use env var or fall back to current origin
const getBackendUrl = () => {
  // If REACT_APP_BACKEND_URL is set, check if we should use it
  if (process.env.REACT_APP_BACKEND_URL) {
    try {
      const envHost = new URL(process.env.REACT_APP_BACKEND_URL).host;
      // Use env var if we're on the same domain (preview) or localhost
      if (window.location.host === envHost || window.location.host.includes('localhost')) {
        return process.env.REACT_APP_BACKEND_URL;
      }
    } catch (e) {
      // Invalid URL in env var, fall through to origin
    }
  }
  // In production/deployed environment, use the current origin
  return window.location.origin;
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

export default API;
